/**
 * Reach specific CSS state-class names shared between TypeScript and `src/css/styles.css`.
 * Each constant must match a rule defined in `styles.css`, when adding a
 * new state class, add the rule there first.
 */

/** Applied to a cell view's root while `useMeasureElement` is hiding it. */
export const MEASURING_CLASS_NAME = 'jj-is-measuring';
